import React, { Fragment } from "react";
import { connect } from "react-redux";
import { withData } from "../common/WithData";
import StudentController from "../api/StudentController";
import { Row, Col } from "react-bootstrap";
import ProgramsView from "../components/ProgramsView";
import DegreeAuditView from "../components/DegreeAuditView";
import AdditionalInformationView from "../components/AdditionalInformationView";
import DegreeInformationView from "../components/DegreeInformationView";
import LeaveOfAbsenceView from "../components/LeaveOfAbsenceView";
import HoldsView from "../components/HoldsView";
import CurrentClassesView from "../components/CurrentClassesView";
import HistoricClassesView from "../components/HistoricClassesView";
import ErrorBoundary from "./ErrorBoundry";

class Academic extends React.Component
{
    studentController: StudentController;
    state = {
        currentClass: null
    }
    constructor(props: any)
    {
        super(props);
        
        this.studentController = new StudentController();
    }

    render(): React.ReactNode
    {
        const currentClass = this.studentController.getCurrentClasses();
        const CurrentClassesData = withData(
            CurrentClassesView,
            "Current Classes",
            async () => await this.studentController.getCurrentClasses()
        );

        const HistoricClassesData = withData(
            HistoricClassesView,
            "Historic Classes",
            async () => await this.studentController.getClassesHistoric(currentClass)
        );

        const ProgramsData = withData(
            ProgramsView,
            "Programs",
            async () => await this.studentController.getCurrentPrograms()
        );

        const DegreeInformationData = withData(
            DegreeInformationView,
            "Academic",
            async () => await this.studentController.getDegreeInformation()
        );

        const LeaveOfAbsenceData = withData(
            LeaveOfAbsenceView,
            "Leave of Absence",
            async () => await this.studentController.getLeavesOfAbsence()
        );

        const HoldsData = withData(
            HoldsView,
            "Holds",
            async () => await this.studentController.getHolds()
        );

        const DegreeAuditData = withData(
            DegreeAuditView,
            "Degree Audit",
            async () => await this.studentController.getDegreeAudit()
        );

        const AdditionalInformationData = withData(
            AdditionalInformationView,
            "Additional Information",
            async () => await this.studentController.getAdditionalInformation()
        );

        return <Fragment>
            <ErrorBoundary>
                <Row>
                    <Col lg={7}>
                        <DegreeInformationData />
                    </Col>
                    <Col lg={5}>
                        <AdditionalInformationData />
                        <LeaveOfAbsenceData />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <HoldsData />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CurrentClassesData />
                        <HistoricClassesData />
                    </Col>
                </Row>
                <Row style={{ marginTop: "30px" }}>
                    <Col >
                        <ProgramsData />
                    </Col>
                </Row>
                <Row style={{ marginTop: "30px" }}>
                    <Col>
                        <DegreeAuditData />
                    </Col>
                </Row>
            </ErrorBoundary>
        </Fragment>;
    }
}

const mapStateToProps = (state: any) => ({
    student: state.student.activeStudent
});

export default connect(mapStateToProps)(Academic);